import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.clients.views.FranchiseeClientListView.';
  public static readonly addPaymentProfile = `${Id.prefix}addPaymentProfile`;
  public static readonly addClient = `${Id.prefix}addClient`;
  public static readonly addContact = `${Id.prefix}addContact`;
  public static readonly clientPlural = `${Id.prefix}clientPlural`;
  public static readonly contactPlural = `${Id.prefix}contactPlural`;
  public static readonly paymentProfilePlural = `${Id.prefix}paymentProfilePlural`;
  public static readonly createClient = `${Id.prefix}createClient`;
  public static readonly createContact = `${Id.prefix}createContact`;
  public static readonly createPaymentProfile = `${Id.prefix}createPaymentProfile`;
  public static readonly editPaymentProfile = `${Id.prefix}editPaymentProfile`;
  public static readonly editContact = `${Id.prefix}editContact`;
  public static readonly addTermsConditions = `${Id.prefix}addTermsConditions`;
  public static readonly editTermsConditions = `${Id.prefix}editTermsConditions`;
  public static readonly termsAndConditions = `${Id.prefix}termsAndConditions`;
}

export class LangFranchiseeClientListView {
  private constructor() {}
  public static addPaymentProfile(): string {
    return interpolate(Id.addPaymentProfile);
  }
  public static addClient(): string {
    return interpolate(Id.addClient);
  }
  public static addContact(): string {
    return interpolate(Id.addContact);
  }
  public static clientPlural(): string {
    return interpolate(Id.clientPlural);
  }
  public static contactPlural(): string {
    return interpolate(Id.contactPlural);
  }
  public static paymentProfilePlural(): string {
    return interpolate(Id.paymentProfilePlural);
  }
  public static createClient(): string {
    return interpolate(Id.createClient);
  }
  public static createContact(): string {
    return interpolate(Id.createContact);
  }
  public static createPaymentProfile(): string {
    return interpolate(Id.createPaymentProfile);
  }
  public static editPaymentProfile(params: { name: string }): string {
    return interpolate(Id.editPaymentProfile, params);
  }
  public static editContact(params: { name: string }): string {
    return interpolate(Id.editContact, params);
  }
  public static termsAndConditions(): string {
    return interpolate(Id.termsAndConditions);
  }
  public static editTermsConditions(params: { name: string }): string {
    return interpolate(Id.editTermsConditions, params);
  }
  public static addTermsConditions(): string {
    return interpolate(Id.addTermsConditions);
  }
}

export class FranchiseeClientListViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.addPaymentProfile,
      "Add {{glossary 'payment-profile'}}",
      'Dialog title for adding a payment profile'
    );
    register.add(Id.addClient, "Add {{glossary 'client'}}", 'Dialog title for adding a client');
    register.add(Id.addContact, "Add {{glossary 'contact'}}", 'Dialog title for adding a contact');
    register.add(Id.clientPlural, "{{glossary 'client:plural'}}", 'Tab title for clients');
    register.add(Id.contactPlural, "{{glossary 'contact:plural'}}", 'Tab title for contacts');
    register.add(Id.paymentProfilePlural, "{{glossary 'payment-profile:plural'}}", 'Tab title for payment profiles');
    register.add(Id.createClient, "Create {{glossary 'client'}}", 'Button label for creating a client');
    register.add(Id.createContact, "Create {{glossary 'contact'}}", 'Button label for creating a contact');
    register.add(
      Id.createPaymentProfile,
      "Create {{glossary 'payment-profile'}}",
      'Button label for creating a payment profile'
    );
    register.add(Id.editPaymentProfile, 'Edit {{name}}', 'Dialog title for editing a payment profile');
    register.add(Id.editContact, 'Edit {{name}}', 'Dialog title for editing a contact');
    register.add(Id.termsAndConditions, "{{glossary 'terms-conditions'}}", 'Tab title for terms and conditions');
    register.add(Id.editTermsConditions, 'Edit {{ name }}', 'Dialog title for editing terms and conditions');
    register.add(
      Id.addTermsConditions,
      "Add {{glossary 'terms-conditions'}}",
      'Dialog title for adding terms and conditions'
    );
  }
}
